import { Box, Typography } from '@mui/material';
import { WordIntroExercise } from '../../../student/mockLessonContent';
import { BLUE, cardSx, INTER, NAVY, POPPINS, SLATE, SURFACE_SOFT } from '../../../student/studentStyles';
import AudioPlayButton from '../../../student/components/AudioPlayButton';
import ExerciseLabel from '../../../student/components/exercises/ExerciseLabel';
import { useExerciseLayout } from './exerciseLayout';

// "Dialog w/ Character Listen" — a new word with its example sentence.
export default function WordIntroExerciseCard({ exercise }: { exercise: WordIntroExercise }) {
    const desktop = useExerciseLayout() === 'desktop';

    return (
        <Box>
            <ExerciseLabel>NEW WORD</ExerciseLabel>
            <Box sx={{ ...cardSx, p: desktop ? 3.5 : 3 }}>
                <Box sx={{ display: desktop ? 'grid' : 'block', gridTemplateColumns: 'minmax(210px, .8fr) minmax(0, 1.2fr)', gap: 3.5, alignItems: 'center' }}>
                    <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{
                            width: 96, height: 96, borderRadius: '24px', mx: 'auto',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            backgroundColor: `${BLUE}14`,
                        }}>
                            <Typography sx={{ fontSize: 48, lineHeight: 1 }}>{exercise.emoji}</Typography>
                        </Box>
                        <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 40, color: NAVY, mt: 2, lineHeight: 1.2 }}>
                            {exercise.hanzi}
                        </Typography>
                        <Typography sx={{ fontFamily: INTER, fontWeight: 600, fontSize: 16, color: BLUE, mt: 0.5 }}>
                            {exercise.pinyin}
                        </Typography>
                        <Typography sx={{ fontFamily: INTER, fontSize: 15, color: SLATE, mt: 0.5 }}>
                            {exercise.meaning}
                        </Typography>
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                            <AudioPlayButton ariaLabel={`Play audio for ${exercise.hanzi}`} size={48} />
                        </Box>
                    </Box>

                    <Box sx={{ mt: desktop ? 0 : 3 }}>
                        <Typography sx={{ fontFamily: INTER, fontWeight: 600, fontSize: 11, letterSpacing: '0.08em', color: SLATE, mb: 1, textAlign: 'left' }}>
                            {desktop ? 'EXAMPLE IN CONTEXT' : 'EXAMPLE'}
                        </Typography>
                        <Box sx={{
                            p: desktop ? 2.5 : 2, borderRadius: '16px', backgroundColor: SURFACE_SOFT,
                            display: 'flex', alignItems: 'center', gap: 1.5, textAlign: 'left',
                        }}>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={{ fontFamily: POPPINS, fontWeight: 500, fontSize: desktop ? 20 : 18, color: NAVY, lineHeight: 1.4 }}>
                                    {exercise.example.hanzi}
                                </Typography>
                                <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, mt: 0.25 }}>
                                    {exercise.example.pinyin}
                                </Typography>
                                <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE, mt: 0.25 }}>
                                    {exercise.example.english}
                                </Typography>
                            </Box>
                            <AudioPlayButton ariaLabel="Play example audio" size={desktop ? 36 : 32} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
